// extracted by mini-css-extract-plugin
export default {"select":"Select_select__yE02S","select-error":"Select_select-error__jBXOv"};